export default "__VITE_ASSET__CI5N1bK5__"